import React, {useEffect, useMemo, useState} from 'react';
import {Box, HStack, VStack} from "native-base";
import FormInput from "../../../../common/FormInput";
import {t} from "../../../../../services/i18n";
import {dbDateFormat} from "../../../../../services/Helpers";
import SharedTimepicker from "../../../../common/SharedTimepicker";
import moment from "moment/moment";
import {GlobalStyleAttributes} from "../../../../../styles/GlobalStyles";
import AppText from "../../../../common/AppText";
import {Radio} from "antd";
import {Colors} from "../../../../../styles/Colors";
import AdvanceSelect from "../../../../common/AdvanceSelect";
import {fetchApi} from "../../../../../services/HTTP";
import {useSelector} from "react-redux";

const MultiPurchase = (props) => {
    const {type, errors, values, setFieldValue, touched} = props
    const box = useSelector(state => state.box?.box)
    const [endDateSelect, setEndDateSelect] = useState("auto")
    const [membershipOptions, setMembershipOptions] = useState([]);
    const dateFormat = useMemo(() => box ? box.locations_box[0].date_format : null, [box])

    useEffect(() => {
        if(endDateSelect === "limited" && !values.end_date) {
            setFieldValue('end_date', moment().add(1,'month').format(dbDateFormat))
        } else if(endDateSelect === "auto") {
            setFieldValue('end_date', null)
        }
    }, [endDateSelect]);

    useEffect(() => {
        if(!values.start_date) {
            setFieldValue('start_date', moment().format(dbDateFormat))
        }
    }, [values.start_date]);

    useEffect(() => {
        getMembershipTypes()
    }, []);

    useEffect(() => {
        if(values.start_date && values.membership_type) {
            calcMembershipEndDate()
        }
    }, [values.start_date, values.membership_type]);

    const getMembershipTypes = async () => {
        const result = await fetchApi('getMembershipTypesOfBox', 'get', null, false, true)
        setMembershipOptions(result.filter(mt => mt.type === type && !mt.is_recurring_payment).map(mt => ({...mt, label: mt.name, value: mt.id})))
    }

    const calcMembershipEndDate = async () => {
        try {
            setFieldValue('endDateRes', null)
            const result = await fetchApi('calcMembershipEndDate', 'post', {membership_type_id: values.membership_type?.id, start_date: values.start_date}, false, true)
            setFieldValue('endDateRes', result)
        } catch (error) {
            console.log('error', error)
            setFieldValue('endDateRes', null)
        }
    }

    const getEndDateLabel = () => {
        if(values.endDateRes) {
            if(values.endDateRes === 'unlimited') return `(${t('unlimited')})`
            else {
                return `(${moment(values.endDateRes).format(dateFormat)})`
            }
        } else return ''
    }


    return (
        <VStack space={'1rem'}>
            <Box width={'100%'}>
                <FormInput containerProps={{mb: '0rem'}}
                           label={t('membership')}
                           width={'100%'}
                           error={(touched.membership_type && errors.membership_type) ? errors.membership_type : null}
                           infoTooltip={t(`multi-purchase-membership-tooltip-${type}`)}
                >
                    <AdvanceSelect options={membershipOptions} initValue={values.membership_type?.id ?? null} onChange={value => setFieldValue('membership_type', value)} isError={touched.membership_type && errors.membership_type}/>
                </FormInput>
            </Box>
            <FormInput containerProps={{mb: '0rem'}} label={t('start')} width={'100%'} error={(errors.start_date) ? errors.start_date : null}>
                <SharedTimepicker type={'date'} value={moment(values.start_date, dbDateFormat)}
                                  onChange={(date) => setFieldValue('start_date', moment(date).format(dbDateFormat))}
                                  textStyle={{fontSize: GlobalStyleAttributes.fonts.standard16}}/>
            </FormInput>
            <VStack space={'0.2rem'}>
                <AppText fontSize={GlobalStyleAttributes.fonts.infoText} mediumFont>{t('end')}</AppText>
                <Radio.Group name={'ending-date-radio'} value={endDateSelect} onChange={(e) => setEndDateSelect(e.target.value)}>
                    <VStack space={'0.5rem'}>
                        <Radio value="auto" size="sm">
                            <AppText fontSize={GlobalStyleAttributes.fonts.heading3} color={Colors.newDesign.mainText} width={'100%'}>{t('calc-end-date-by-mt')} {getEndDateLabel()}</AppText>
                        </Radio>
                        <Radio value="limited" size="sm">
                            <HStack alignItems={'center'} space={'5px'}>
                                <AppText fontSize={GlobalStyleAttributes.fonts.heading3} color={Colors.newDesign.mainText}>{t('manualEndDate')}</AppText>
                                {endDateSelect === 'limited' && <SharedTimepicker type={'date'} value={moment(values.end_date, dbDateFormat)} onChange={(date) => setFieldValue('end_date', moment(date).format(dbDateFormat))} textStyle={{fontSize: GlobalStyleAttributes.fonts.standard16}} isError={touched.end_date && errors.end_date}/>}
                            </HStack>
                            {endDateSelect === 'limited' && errors.end_date && <AppText fontSize={GlobalStyleAttributes.fonts.infoText} color={Colors.error} mediumFont>{errors.end_date}</AppText>}
                        </Radio>
                    </VStack>
                </Radio.Group>
            </VStack>
            <FormInput
                value={values.comment}
                containerProps={{ mb: '0rem' }}
                onChangeCallback={(comment) => setFieldValue('comment', comment)}
                label={t('commentOptional')}
                width={'100%'}/>
        </VStack>
    );
};

export default MultiPurchase;